import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const q = (path) => async () => (await api.get(path)).data;

export const useProducts = () =>
  useQuery({ queryKey: ["products"], queryFn: q("/products") });

export const useProduct = (slug) =>
  useQuery({ queryKey: ["product", slug], queryFn: q(`/products/${slug}`), enabled: !!slug });

export const useBrand = () =>
  useQuery({ queryKey: ["brand"], queryFn: q("/brand-settings") });

export const useArticle = (slug) =>
  useQuery({ queryKey: ["article", slug], queryFn: q(`/articles/${slug}`), enabled: !!slug, retry: false });

export const useProgrammes = () =>
  useQuery({ queryKey: ["programmes"], queryFn: q("/programmes") });

export const useStories = () =>
  useQuery({ queryKey: ["stories"], queryFn: q("/stories") });

export const useArticles = () =>
  useQuery({ queryKey: ["articles"], queryFn: q("/articles") });

export const useListened = () =>
  useQuery({ queryKey: ["listened"], queryFn: q("/listened") });
